import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useAuthContext } from '@/ui/contexts/AuthContext'

import { unreadCountInstance } from '../..'
import { UnreadCountsEnum } from '../../domain/models/UnreadCountsEnum'
import { setChatNotificationsCount } from '../../services/cache/UnreadCountCacheManager'

export function useChatNotificationsCounterEvents() {
  const queryClient = useQueryClient()
  const { personaSession } = useAuthContext()

  useEffect(() => {
    if (!personaSession?.personaId) return

    const unsubscribeUserChatsNotificationsCount =
      unreadCountInstance.getUnreadCount({
        profileId: personaSession.personaId,
        countPath: UnreadCountsEnum.enum.chats,
        onValue: (snapshot) => {
          const count = snapshot.val() as number
          setChatNotificationsCount({ count }, queryClient)
        }
      })

    return () => {
      unsubscribeUserChatsNotificationsCount()
    }
  }, [personaSession?.personaId])
}
